<template>
	<app tabbar :create-button="!!createPath" @create="navigateTo(createPath)">
		<tab-list v-show="tabList.length > 1" v-model="currentTabIndex" :tab="tabList" @change="updateList"></tab-list>
		<scroll-list ref="list">
			<template v-slot="{data, index}">
				<scroll-item v-if="currentTab.type == 'project'">
					<div class="code">项目编号：{{data.code}}</div>
					<div class="name">{{data.name}}</div>
					<div class="info">
						<span>已购买保函：</span>
						<span v-if="data.bx_count == 0" style="color: #E63633;">未购买</span>
						<span v-else>{{data.bx_count}}份</span>
					</div>
					<div class="info">
						<span>项目人员：</span>
						<span v-if="data.set_ry_count == 0" style="color: #E63633;">未设置</span>
						<span v-else>已设置</span>
					</div>
					<button-group v-if="power('5')" slot="button">
						<c-button color="gray" hollow @click="navigateTo('/project_detail', {id: data.id})">查看详情</c-button>
						<c-button color="gray" hollow v-if="data.state < 3" @click="navigateTo('/project_edit', {id: data.id})">编辑</c-button>
						<c-button v-if="data.state == 3" @click="navigateTo('/project_bidding', {id: data.id})">设置中标企业</c-button>
						<c-button color="red" v-if="data.state == 1" @click="deleteProjectHandle(data, index)">删除</c-button>
					</button-group>
					<button-group v-if="power('7')" slot="button">
						<c-button color="gray" hollow @click="navigateTo('/project_detail', {id: data.id})">查看详情</c-button>
						<c-button v-if="data.jldw_name && data.set_ry_count == 0" @click="navigateTo('/person_change_apply', {projectId: data.id})">设置项目人员</c-button>
						<c-button color="gray" hollow v-if="data.jldw_name" @click="unbindHandle(data)">解绑监理关系</c-button>
						<c-button color="gray" hollow v-else @click="copyCode(data)">项目邀请码</c-button>
					</button-group>
					<button-group v-if="power('8')" slot="button">
						<c-button color="gray" hollow @click="navigateTo('/project_detail', {id: data.id})">查看详情</c-button>
					</button-group>
				</scroll-item>
				
				<scroll-item v-else>
					<div class="flex-between-center">
						<div class="code">申请时间：{{data.create_date}}</div>
						<div class="info"><span :style="{'color': personState[data.state].color}">{{personState[data.state].name}}</span></div>
					</div>
					<div class="name">{{data.project_name}}</div>
					<button-group slot="button">
						<c-button v-if="data.state == 4 && power('7')" @click="navigateTo('/person_change_apply', {id: data.id})">重新编辑</c-button>
						<c-button v-if="data.state == 1 && power('8')" @click="navigateTo('/person_change_detail', {id: data.id})">审批</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/person_change_detail', {id: data.id})">查看详情</c-button>
						<c-button v-if="data.state == 4 && power('7')" @click="deletePersonChangeHandle(data, index)">删除</c-button>
					</button-group>
				</scroll-item>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				currentTabIndex: 0
			}
		},
		
		computed: {
			...mapGetters(['power', 'projectState', 'personState']),
			
			tabList() {
				return [{
					type: 'project',
					name: this.power('5') ? '项目列表' : this.power('7') ? '中标项目' : '监理项目',
					url: '/project/list'
				}].concat(this.power('5') ? [] : [{
					type: 'person',
					name: this.power('7') ? '项目人员变更' : '人员变更审批',
					url: '/project/ry/list'
				}])
			},
			
			currentTab() {
				return this.tabList[this.currentTabIndex];
			},
			
			createPath() {
				if (this.power('5')) {
					return '/project_edit';
				}
				
				if (this.power('7')) {
					return this.currentTabIndex == 1 ? '/person_change_apply' : '/bidding_create';
				}
				
				if (this.power('8') && this.currentTabIndex == 0) {
					return '/project_supervision';
				}
			}
		},
		
		methods: {
			updateList(data) {
				this.$refs.list.load({
					url: data.url
				});
			},
			
			deleteProjectHandle(data, index) {
				this.$confirm({
					text: '确定要删除此项目吗？',
					resolve: () => {
						this.request({
							url: '/project/delete',
							data: {
								project_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.list.delete(index);
							}
						});
					}
				});
			},
			
			unbindHandle(data) {
				this.$confirm({
					text: '确定要解绑监理关系吗？',
					message: `解除绑定后，监理单位（${data.jldw_name}）将无法审批或监理此项目`,
					resolve: () => {
						this.request({
							url: '/project/clear_jl',
							data: {
								project_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '解绑成功'
								});
								data.jldw_name = '';
							}
						});
					}
				});
			},
			
			copyCode(data) {
				this.request({
					url: '/project/yq_code',
					data: {
						project_id: data.id,
						type: 1
					},
					loading: true,
					success: data => {
						this.clipboard(data, false);
						this.$confirm({
							icon: 'message',
							text: '项目邀请码已复制',
							message: `此项目的邀请码为：<span style="color: #E63633;">${data}</span>，已复制到内存，你可以直接粘贴发送给相关监理单位。`,
							cancelButton: false
						});
					}
				});
			},
			
			deletePersonChangeHandle(data, index) {
				this.$confirm({
					text: '确定要删除此变更申请吗？',
					resolve: () => {
						this.request({
							url: '/project/ry/delete',
							data: {
								ry_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.list.delete(index);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
